module.exports = __webpack_public_path__ + "static/media/7.180af2a7.jpeg";